import React from "react";
import style from "./VideosCard.module.css";
import play from "../../../assets/contenido/play.png";

export const VideosCard = ({ vid, title }) => {
  return (
    <div className={style.container}>
      <div className={style.vidCont}>
        <img className={style.vid} src={vid} alt="vid" />
        <button className={style.play}>
          {" "}
          <img src={play} alt="play" />
        </button>
      </div>
      <h3 className={style.title}>{title}</h3>
    </div>
  );
};
